<ng-container *ngIf="dates && data">
    <div class="cmps-detail-grid--row">
        <div></div>
        <ng-container *ngFor="let i of dates">
            <div>
                {{ i.startDate | cmpsDate: 'MMM d' }} -
                {{ i.endDate | cmpsDate: 'MMM d' }}
            </div>
        </ng-container>
    </div>
    <div class="cmps-detail-grid--row">
        <div>{{ _i18n._725_ACTUAL | translate }}</div>
        <ng-container *ngFor="let i of data">
            <div>
                <span [style.color]="i.arrowColour">{{
                    i.actual == null ? '-' : (i.actual | cmpsNumber: '1.2-2')
                }}</span>
                <cmps-icon
                    [style.fill]="i.arrowColour"
                    [svgIcon]="i.arrow"
                    *ngIf="i.trend"
                ></cmps-icon>
            </div>
        </ng-container>
    </div>
    <div class="cmps-detail-grid--row">
        <div>{{ _i18n._726_TARGET | translate }}</div>
        <ng-container *ngFor="let i of data">
            <div>
                {{ i.target == null ? '-' : (i.target | cmpsNumber: '1.2-2') }}
            </div>
        </ng-container>
    </div>
    <div class="cmps-detail-grid--row">
        <div>{{ _i18n._768___TO_TARGET | translate }}</div>
        <ng-container *ngFor="let i of data">
            <div [style.color]="i.targetThresholdColour">
                {{
                    i.targetPercent == null
                        ? '-'
                        : i.targetPercent >= 999
                        ? '999+'
                        : (i.targetPercent | number: '1.2-2')
                }}
            </div>
        </ng-container>
    </div>
    <div class="cmps-detail-grid--row">
        <div>{{ _i18n._721_GOAL | translate }}</div>
        <ng-container *ngFor="let i of data">
            <div>
                {{ i.goal == null ? '-' : (i.goal | cmpsNumber: '1.2-2') }}
            </div>
        </ng-container>
    </div>
    <div class="cmps-detail-grid--row">
        <div>{{ _i18n._767___TO_GOAL | translate }}</div>
        <ng-container *ngFor="let i of data">
            <div [style.color]="i.goalThresholdColour">
                {{
                    i.goalPercent == null
                        ? '-'
                        : (i.goalPercent | cmpsNumber: '1.2-2')
                }}
            </div>
        </ng-container>
    </div>
    <div class="cmps-detail-grid--row">
        <div>{{ _i18n._7368_OPPORTUNITY_THRESHOLD | translate }}</div>
        <ng-container *ngFor="let i of data">
            <!--yes, no null check. this is to match predecessor behaviour-->
            <div>
                {{
                    !i.opportunityThreshold
                        ? '-'
                        : (i.opportunityThreshold | cmpsNumber: '1.2-2')
                }}
            </div>
        </ng-container>
    </div>
    <div class="cmps-detail-grid--row">
        <div>{{ _i18n._7369_GAP_TO_OPPORTUNITY_LINE | translate }}</div>
        <ng-container *ngFor="let i of data">
            <div>{{ i.gap == null ? '-' : (i.gap | cmpsNumber: '1.2-2') }}</div>
        </ng-container>
    </div>
</ng-container>
